"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[576],{

/***/ 38053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports IconAlarm, IconAndroid, IconApple, IconArrowDown, IconArrowLeft, IconArrowRight, IconArrowUp, IconBaloon, IconBell, IconBook, IconBuildings, IconBurger, IconCalendarClock, IconCalendarMail, IconCalendar, IconCamera, IconCar, IconCardsOverlap, IconCart, IconChart, IconChat, IconCheckCircle, IconCheckSquare, IconCheck, IconChevronCircleDown, IconChevronCircleLeft, IconChevronCircleRight, IconChevronCircleUp, IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp, IconClock24, IconClock, IconComputer, IconCreditCard, IconCrossCircle, IconCrossSquare, IconCross, IconDamageThirdParties, IconDevices, IconDiamond, IconDocumentAlert, IconDocumentSigned, IconDocument, IconDownload, IconEuro, IconExclamationCircle, IconExclamationTriangle, IconExternalLink, IconEyeSlashed, IconEye, IconFacebook, IconFamilyRc, IconFax, IconFloppyDisk, IconFolder, IconGear, IconGift, IconGrid, IconHomeDamageEbike, IconHomeDamageFamily, IconHomeDamagePets, IconHomeDamageThirdParties, IconHomeDomesticThefts, IconHomeEmergenciesRepairs, IconHomeFireExplosion, IconHomeFurnitureContent, IconHomeInjuriesFamily, IconHomeInjuriesFreetime, IconHomeInsuranceHome, IconHomeLegalProtection, IconHomeNaturalEvents, IconHomeRobberiesOutside, IconHomeTelephoneLegalAdvice, IconHomeTheftValuable, IconHome, IconHourglass, IconIdCard, IconInfoCircle, IconInstagram, IconInsuranceHome, IconJobs, IconKey, IconKeyhole, IconLink, IconLinkedin, IconListCircle, IconList, IconLoader, IconLocalProtection, IconLockOpen, IconLock, IconLogout, IconMagicWand, IconMagnifyingGlass, IconMail, IconMapMarker, IconMedal, IconMinusCircle, IconMinusSquare, IconMinus, IconMoped, IconMoreHorizontalCircle, IconMoreHorizontal, IconMoreVertical, IconMotorcycle, IconOdometer, IconPaperPlane, IconPaperclip, IconPec, IconPenForm, IconPen, IconPhone24, IconPhone, IconPlate, IconPlusCircle, IconPlusSquare, IconPlus, IconPound, IconPrima, IconQuestionCircle, IconReload, IconShieldCheck, IconSki, IconSmartphone, IconStarFilled, IconStar, IconSteeringWheel, IconSwitch, IconTablet, IconThumbUp, IconTrashBin, IconTshirtSport, IconTwitter, IconUmbrella, IconUpload, IconUserCheck, IconUserCircle, IconUserCross, IconUserMinus, IconUserPlus, IconUser, IconUsers, IconVan, IconVehicleCollisionKasko, IconVehicleDriverInjuries, IconVehicleFullKasko, IconVehicleGlasses, IconVehicleLegalProtection, IconVehicleNaturalEvents, IconVehicleRicourseWaiver, IconVehicleRoadsideAssistance, IconVehicleSecuredBonus, IconVehicleTheftFire, IconVehicleVandalism, IconWallet, IconWhatsapp, IconWrench, IconYoutube, PyxisIcon */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44747);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var IconAlarm = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconAlarm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconAndroid = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconAndroid;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconApple = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconApple;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconArrowDown = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconArrowDown;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconArrowLeft = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconArrowLeft;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconArrowRight = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconArrowRight;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconArrowUp = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconArrowUp;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconBaloon = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconBaloon;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconBell = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconBell;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconBook = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconBook;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconBuildings = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconBuildings;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconBurger = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconBurger;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCalendarClock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCalendarClock;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCalendarMail = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCalendarMail;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCalendar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCalendar;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCamera = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCamera;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCar;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCardsOverlap = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCardsOverlap;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCart = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCart;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChart = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChart;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChat = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChat;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCheckCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCheckCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCheckSquare = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCheckSquare;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCheck = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCheck;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronCircleDown = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronCircleDown;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronCircleLeft = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronCircleLeft;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronCircleRight = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronCircleRight;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronCircleUp = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronCircleUp;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronDown = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronDown;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronLeft = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronLeft;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronRight = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronRight;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconChevronUp = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconChevronUp;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconClock24 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconClock24;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconClock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconClock;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconComputer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconComputer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCreditCard = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCreditCard;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCrossCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCrossCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCrossSquare = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCrossSquare;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconCross = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconCross;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDamageThirdParties = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDamageThirdParties;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDevices = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDevices;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDiamond = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDiamond;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDocumentAlert = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDocumentAlert;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDocumentSigned = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDocumentSigned;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDocument = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDocument;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconDownload = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconDownload;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconEuro = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconEuro;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconExclamationCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconExclamationCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconExclamationTriangle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconExclamationTriangle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconExternalLink = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconExternalLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconEyeSlashed = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconEyeSlashed;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconEye = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconEye;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconFacebook = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconFacebook;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconFamilyRc = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconFamilyRc;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconFax = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconFax;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconFloppyDisk = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconFloppyDisk;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconFolder = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconFolder;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconGear = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconGear;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconGift = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconGift;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconGrid = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconGrid;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeDamageEbike = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeDamageEbike;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeDamageFamily = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeDamageFamily;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeDamagePets = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeDamagePets;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeDamageThirdParties = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconHomeDamageThirdParties;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeDomesticThefts = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeDomesticThefts;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeEmergenciesRepairs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconHomeEmergenciesRepairs;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeFireExplosion = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeFireExplosion;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeFurnitureContent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeFurnitureContent;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeInjuriesFamily = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeInjuriesFamily;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeInjuriesFreetime = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeInjuriesFreetime;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeInsuranceHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeInsuranceHome;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeLegalProtection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeLegalProtection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeNaturalEvents = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeNaturalEvents;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeRobberiesOutside = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeRobberiesOutside;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeTelephoneLegalAdvice = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconHomeTelephoneLegalAdvice;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHomeTheftValuable = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHomeTheftValuable;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHome;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconHourglass = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconHourglass;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconIdCard = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconIdCard;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconInfoCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconInfoCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconInstagram = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconInstagram;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconInsuranceHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconInsuranceHome;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconJobs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconJobs;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconKey = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconKey;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconKeyhole = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconKeyhole;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLink = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLink;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLinkedin = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLinkedin;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconListCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconListCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconList;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLoader = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLoader;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLocalProtection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLocalProtection;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLockOpen = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLockOpen;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLock = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLock;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconLogout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconLogout;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMagicWand = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMagicWand;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMagnifyingGlass = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMagnifyingGlass;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMail = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMail;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMapMarker = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMapMarker;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMedal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMedal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMinusCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMinusCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMinusSquare = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMinusSquare;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMinus = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMinus;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMoped = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMoped;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMoreHorizontalCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMoreHorizontalCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMoreHorizontal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMoreHorizontal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMoreVertical = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMoreVertical;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconMotorcycle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconMotorcycle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconOdometer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconOdometer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPaperPlane = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPaperPlane;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPaperclip = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPaperclip;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPec = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPec;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPenForm = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPenForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPen = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPen;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPhone24 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPhone24;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPhone = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPhone;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPlate = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPlate;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPlusCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPlusCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPlusSquare = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPlusSquare;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPlus = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPlus;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPound = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPound;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconPrima = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconPrima;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconQuestionCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconQuestionCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconReload = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconReload;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconShieldCheck = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconShieldCheck;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconSki = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconSki;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconSmartphone = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconSmartphone;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconStarFilled = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconStarFilled;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconStar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconStar;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconSteeringWheel = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconSteeringWheel;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconSwitch = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconSwitch;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconTablet = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconTablet;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconThumbUp = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconThumbUp;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconTrashBin = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconTrashBin;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconTshirtSport = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconTshirtSport;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconTwitter = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconTwitter;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUmbrella = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUmbrella;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUpload = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUpload;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUserCheck = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUserCheck;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUserCircle = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUserCircle;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUserCross = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUserCross;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUserMinus = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUserMinus;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUserPlus = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUserPlus;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUser = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUser;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconUsers = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconUsers;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVan = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVan;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleCollisionKasko = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconVehicleCollisionKasko;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleDriverInjuries = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconVehicleDriverInjuries;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleFullKasko = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVehicleFullKasko;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleGlasses = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVehicleGlasses;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleLegalProtection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconVehicleLegalProtection;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleNaturalEvents = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVehicleNaturalEvents;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleRicourseWaiver = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconVehicleRicourseWaiver;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleRoadsideAssistance = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
    return module.IconVehicleRoadsideAssistance;
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleSecuredBonus = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVehicleSecuredBonus;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleTheftFire = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVehicleTheftFire;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconVehicleVandalism = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconVehicleVandalism;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconWallet = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconWallet;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconWhatsapp = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconWhatsapp;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconWrench = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconWrench;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var IconYoutube = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98647)).then(function(module) {
        return module.IconYoutube;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(null /* weak dependency, without id */)
            ];
        }
    }
});
var PyxisIcon = function(_param) {
    var name = _param.name, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "name"
    ]);
    switch(name){
        case "IconAlarm":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconAlarm, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconAndroid":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconAndroid, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconApple":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconApple, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconArrowDown":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconArrowDown, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconArrowLeft":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconArrowLeft, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconArrowRight":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconArrowRight, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconArrowUp":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconArrowUp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconBaloon":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBaloon, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconBell":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBell, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconBook":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBook, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconBuildings":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBuildings, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconBurger":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBurger, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCalendarClock":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCalendarClock, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCalendarMail":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCalendarMail, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCalendar":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCalendar, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCamera":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCamera, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCar":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCar, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCardsOverlap":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCardsOverlap, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCart":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCart, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChart":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChart, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChat":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChat, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCheckCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCheckCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCheckSquare":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCheckSquare, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCheck":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCheck, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronCircleDown":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronCircleDown, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronCircleLeft":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronCircleLeft, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronCircleRight":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronCircleRight, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronCircleUp":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronCircleUp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronDown":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronDown, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronLeft":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronLeft, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronRight":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronRight, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconChevronUp":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconChevronUp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconClock24":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconClock24, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconClock":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconClock, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconComputer":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconComputer, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCreditCard":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCreditCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCrossCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCrossCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCrossSquare":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCrossSquare, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconCross":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconCross, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDamageThirdParties":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDamageThirdParties, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDevices":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDevices, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDiamond":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDiamond, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDocumentAlert":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDocumentAlert, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDocumentSigned":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDocumentSigned, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDocument":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDocument, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconDownload":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconDownload, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconEuro":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconEuro, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconExclamationCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconExclamationCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconExclamationTriangle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconExclamationTriangle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconExternalLink":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconExternalLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconEyeSlashed":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconEyeSlashed, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconEye":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconEye, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconFacebook":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconFacebook, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconFamilyRc":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconFamilyRc, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconFax":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconFax, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconFloppyDisk":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconFloppyDisk, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconFolder":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconFolder, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconGear":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconGear, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconGift":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconGift, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconGrid":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconGrid, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeDamageEbike":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeDamageEbike, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeDamageFamily":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeDamageFamily, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeDamagePets":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeDamagePets, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeDamageThirdParties":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeDamageThirdParties, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeDomesticThefts":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeDomesticThefts, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeEmergenciesRepairs":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeEmergenciesRepairs, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeFireExplosion":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeFireExplosion, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeFurnitureContent":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeFurnitureContent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeInjuriesFamily":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeInjuriesFamily, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeInjuriesFreetime":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeInjuriesFreetime, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeInsuranceHome":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeInsuranceHome, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeLegalProtection":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeLegalProtection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeNaturalEvents":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeNaturalEvents, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeRobberiesOutside":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeRobberiesOutside, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeTelephoneLegalAdvice":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeTelephoneLegalAdvice, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHomeTheftValuable":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHomeTheftValuable, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHome":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHome, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconHourglass":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconHourglass, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconIdCard":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconIdCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconInfoCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconInfoCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconInstagram":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconInstagram, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconInsuranceHome":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconInsuranceHome, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconJobs":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconJobs, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconKey":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconKey, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconKeyhole":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconKeyhole, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLink":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLinkedin":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLinkedin, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconListCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconListCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconList":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLoader":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLoader, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLocalProtection":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLocalProtection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLockOpen":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLockOpen, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLock":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLock, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconLogout":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconLogout, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMagicWand":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMagicWand, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMagnifyingGlass":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMagnifyingGlass, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMail":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMail, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMapMarker":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMapMarker, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMedal":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMedal, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMinusCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMinusCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMinusSquare":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMinusSquare, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMinus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMinus, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMoped":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMoped, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMoreHorizontalCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMoreHorizontalCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMoreHorizontal":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMoreHorizontal, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMoreVertical":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMoreVertical, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconMotorcycle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconMotorcycle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconOdometer":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconOdometer, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPaperPlane":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPaperPlane, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPaperclip":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPaperclip, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPec":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPec, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPenForm":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPenForm, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPen":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPen, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPhone24":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPhone24, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPhone":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPhone, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPlate":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPlate, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPlusCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPlusCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPlusSquare":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPlusSquare, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPlus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPlus, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPound":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPound, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconPrima":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconPrima, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconQuestionCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconQuestionCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconReload":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconReload, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconShieldCheck":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconShieldCheck, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconSki":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconSki, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconSmartphone":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconSmartphone, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconStarFilled":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconStarFilled, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconStar":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconStar, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconSteeringWheel":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconSteeringWheel, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconSwitch":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconSwitch, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconTablet":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconTablet, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconThumbUp":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconThumbUp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconTrashBin":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconTrashBin, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconTshirtSport":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconTshirtSport, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconTwitter":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconTwitter, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUmbrella":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUmbrella, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUpload":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUpload, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUserCheck":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUserCheck, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUserCircle":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUserCircle, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUserCross":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUserCross, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUserMinus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUserMinus, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUserPlus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUserPlus, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUser":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUser, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconUsers":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconUsers, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVan":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVan, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleCollisionKasko":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleCollisionKasko, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleDriverInjuries":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleDriverInjuries, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleFullKasko":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleFullKasko, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleGlasses":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleGlasses, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleLegalProtection":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleLegalProtection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleNaturalEvents":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleNaturalEvents, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleRicourseWaiver":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleRicourseWaiver, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleRoadsideAssistance":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleRoadsideAssistance, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleSecuredBonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleSecuredBonus, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleTheftFire":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleTheftFire, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconVehicleVandalism":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconVehicleVandalism, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconWallet":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWallet, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconWhatsapp":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWhatsapp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconWrench":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrench, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
        case "IconYoutube":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconYoutube, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
    }
    return null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (PyxisIcon);


/***/ }),

/***/ 6893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t3": function() { return /* binding */ ResponsiveImage; }
});

// UNUSED EXPORTS: ImageMemo, getOriginalImageDimensions, getResponsiveImageUrl, imageBuilder

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sanity/image-url/lib/browser/image-url.umd.js
var image_url_umd = __webpack_require__(6803);
var image_url_umd_default = /*#__PURE__*/__webpack_require__.n(image_url_umd);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./helpers/utils/number.ts
/**
 * Wraps a number when it breaches the defined range.
 *
 * wrap accepts a range, defined as a min and max.
 *
 * When a third number is provided:
 *
 * If it lies within the range, it is returned.
 * If it lies outside the range, it is wrapped back around:
 *
 * wrap(0, 1, 0.5); // 0.5
 * wrap(0, 1, 1.5); // 0.5
 */ var wrap = function(min, max, v) {
    var rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};
/**
 * Round a number to the nearest multiple of another number.
 */ var roundToNearest = function(multiple, v) {
    if (multiple === 0) return Math.round(v);
    return Math.round(v / multiple) * multiple;
};
/**
 * Random number between two numbers.
 */ var randomBetween = function(min, max) {
    return Math.random() * (max - min) + min;
};

// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./components/meta/ScriptJsonLd.tsx
var ScriptJsonLd = __webpack_require__(18164);
;// CONCATENATED MODULE: ./components/images/ResponsiveImage.tsx











var imageBuilder = image_url_umd_default()({
    projectId: "k6y0mpps",
    dataset: "production"
});
var IMAGE_QUALITY = 85;
var ratioClasses = {
    auto: "aspect-auto",
    "1/1": "aspect-[1/1]",
    "3/2": "aspect-[3/2]",
    "16/9": "aspect-[16/9]",
    "19/27": "aspect-[19/27]",
    "2/1": "aspect-[2/1]",
    "13/8": "aspect-[13/8]",
    "4/3": "aspect-[4/3]",
    "21/9": "aspect-[21/9]"
};
var ResponsiveImage = function(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop, hotspot = param.hotspot, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _layout = param.layout, layout = _layout === void 0 ? "intrinsic" : _layout, objectFit = param.objectFit, className = param.className, _preventResize = param.preventResize, preventResize = _preventResize === void 0 ? false : _preventResize, priority = param.priority, ratio = param.ratio, _roundSize = param.roundSize, roundSize = _roundSize === void 0 ? 0 : _roundSize, dpr = param.dpr;
    var wrapperRef = (0,react.useRef)(null);
    var placeholderRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), responsiveSrc = ref[0], setResponsiveSrc = ref[1];
    var ref1 = (0,react.useState)(null), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(0), wrapperWidth = ref2[0], setWrapperWidth = ref2[1];
    var ref3 = (0,react.useState)(0), wrapperHeight = ref3[0], setWrapperHeight = ref3[1];
    var debouncedWrapperWidth = (0,useDebounce/* useDebounce */.N)(wrapperWidth, 500);
    var debouncedWrapperHeight = (0,useDebounce/* useDebounce */.N)(wrapperHeight, 500);
    var originalDimensions = getOriginalImageDimensions(src);
    if (!width) width = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.width;
    if (!height) height = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.height;
    var aspectRatio = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.aspectRatio;
    var placeHolderSrc;
    // if (ratio) {
    //   height = (+width / +ratio.split(':')[0]) * +ratio.split(':')[1];
    // }
    if (src && typeof src === "string" && src.indexOf("sanity.io") > -1) {
        placeHolderSrc = getResponsiveImageUrl({
            src: src,
            width: 16,
            height: 16 / (+width / +height),
            hotspot: hotspot,
            crop: crop,
            blur: 10,
            dpr: dpr
        });
    }
    (0,react.useEffect)(function() {
        if (state === null) setState("loading");
    }, [
        state
    ]);
    var onResize = (0,react.useCallback)(function() {
        if (!src) return;
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) return;
        if (!placeHolderSrc) return;
        if (typeof src !== "string") return;
        var rect = wrapperRef.current.getBoundingClientRect();
        var w = roundToNearest(roundSize, rect.width);
        var h = roundToNearest(roundSize, rect.height);
        setWrapperWidth(w);
        setWrapperHeight(h);
    }, [
        src,
        placeHolderSrc,
        roundSize
    ]);
    /**
   * Listen to window resizes
   */ (0,react.useEffect)(function() {
        if (!src) return;
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) return;
        if (typeof ResizeObserver === "undefined") return;
        var resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(wrapperRef.current);
        (function() {
            return resizeObserver.disconnect();
        });
    }, [
        wrapperRef,
        src,
        onResize
    ]);
    /**
   * when the debounced window width changes
   * generate new source for sanity images
   */ (0,react.useEffect)(function() {
        if (!src) return;
        if (!placeHolderSrc) return;
        if (typeof src !== "string") return;
        var rect = wrapperRef.current.getBoundingClientRect();
        var newWidth = roundToNearest(roundSize, rect.width);
        var newHeight = roundToNearest(roundSize, rect.height);
        var quality = IMAGE_QUALITY;
        if (preventResize === true) {
            // Do we need to factor in crops as well? https://github.com/sanity-io/hydrogen-sanity-demo/blob/main/src/components/SanityImage.client.jsx#L100
            newHeight = rect.width / (+width / +height);
            quality = null;
        }
        // for layouts where height depends on the image, use image ratio
        if (newHeight === 0) newHeight = newWidth / (+width / +height);
        setResponsiveSrc(getResponsiveImageUrl({
            src: src,
            width: newWidth,
            height: newHeight,
            hotspot: hotspot,
            crop: crop,
            quality: quality,
            dpr: dpr
        }));
    }, [
        wrapperWidth,
        debouncedWrapperHeight,
        width,
        height,
        src,
        crop,
        hotspot,
        preventResize,
        placeHolderSrc,
        roundSize, 
    ]);
    var onImageLoad = (0,react.useCallback)(function() {
        setState("loaded");
    }, []);
    var imageJsonLd = {
        "@context": "https://schema.org/",
        "@type": "ImageObject",
        contentUrl: src,
        description: alt
    };
    if (!src) return null;
    var _obj;
    return(// disable margin underneath next image until classes can be applied to next image directly
    // https://github.com/vercel/next.js/discussions/22861
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("image", "text-0 h-full w-full", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "relative", !objectFit), (0,_define_property/* default */.Z)(_obj, ratioClasses[ratio], ratio), _obj)),
        ref: wrapperRef,
        children: [
            priority && responsiveSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: "".concat(responsiveSrc, "&q=").concat(IMAGE_QUALITY)
                })
            }),
            (state === "loading" || state === "loaded") && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: responsiveSrc || placeHolderSrc || src,
                className: className,
                alt: alt,
                layout: layout,
                width: layout === "fill" ? null : width,
                height: layout === "fill" ? null : height,
                objectFit: objectFit,
                priority: priority,
                loader: function(param) {
                    var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality;
                    return "".concat(src, "&q=").concat(quality);
                },
                quality: IMAGE_QUALITY,
                onLoadingComplete: onImageLoad
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: src,
                        className: className,
                        alt: alt,
                        width: width ? width : "auto",
                        height: height ? height : "auto"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScriptJsonLd/* ScriptJsonLd */.a, {
                data: imageJsonLd
            })
        ]
    }));
};
var ImageMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ResponsiveImage)));
function getResponsiveImageUrl(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop, hotspot = param.hotspot, _blur = param.blur, blur = _blur === void 0 ? 0 : _blur, _quality = param.quality, quality = _quality === void 0 ? IMAGE_QUALITY : _quality, dpr = param.dpr;
    if (!src) return null;
    var ref = getOriginalImageDimensions(src), originalWidth = ref.width, originalHeight = ref.height;
    dpr = dpr ? dpr :  false ? 0 : window.devicePixelRatio || 1;
    var newSrc = imageBuilder.image(src).auto("format");
    if (quality) newSrc = newSrc.quality(IMAGE_QUALITY);
    if (blur) newSrc = newSrc.blur(blur);
    if (width) newSrc = newSrc.width(Math.ceil(width * dpr));
    if (height) newSrc = newSrc.height(Math.ceil(height * dpr));
    if ((hotspot === null || hotspot === void 0 ? void 0 : hotspot.x) && (hotspot === null || hotspot === void 0 ? void 0 : hotspot.y)) newSrc = newSrc.crop("focalpoint").focalPoint(hotspot.x, hotspot.y).fit("crop");
    if (crop && (crop === null || crop === void 0 ? void 0 : crop.left) !== null && (crop === null || crop === void 0 ? void 0 : crop.top) !== null && (crop === null || crop === void 0 ? void 0 : crop.right) !== null && (crop === null || crop === void 0 ? void 0 : crop.bottom) !== null) {
        var rect = {
            left: Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.left) || 0)),
            top: Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.top) || 0)),
            width: originalWidth - Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.right) || 0)) - Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.left) || 0)),
            height: originalHeight - Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.bottom) || 0)) - Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.top) || 0))
        };
        if (rect.width <= 0) rect.width = originalWidth;
        if (rect.height <= 0) rect.height = originalHeight;
        newSrc = newSrc.rect(rect.left, rect.top, rect.width, rect.height);
    }
    return newSrc.url();
}
function getOriginalImageDimensions(src) {
    var ref;
    if (!src) return {
        width: 0,
        height: 0,
        aspectRatio: 0
    };
    var filename = (ref = src === null || src === void 0 ? void 0 : src.split("/")) === null || ref === void 0 ? void 0 : ref.pop();
    var pattern = /-(\d+x\d+)/;
    var ref1 = (0,_sliced_to_array/* default */.Z)(pattern.exec(filename), 2), dimensions = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(dimensions.split("x").map(function(v) {
        return parseInt(v, 10);
    }), 2), width = ref2[0], height = ref2[1];
    var aspectRatio = width / height;
    return {
        width: width,
        height: height,
        aspectRatio: aspectRatio
    };
}


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * Usage:
 * const [searchTerm, setSearchTerm] = useState("");
 * const debouncedSearchTerm = useDebounce(searchTerm, 500);
 */ 
function useDebounce(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            return clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}


/***/ })

}]);